<h4 class="modal-header">
</h4>
<div class="modal-body message">
    <p>{{message}}</p>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="onConfirm()">{{okBtn}}</button>
</div>
